<template>
  <b-table
    :items="instituicoes"
    :fields="campos"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    responsive="sm"
    show-empty
    stacked="md"
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
        <b-dropdown-item
          v-if="podeEditar"
          @click="irPara('editar-instituicao-ensino', item.item.id)"
        >
          {{ $t('GERAL.EDITAR') }}
        </b-dropdown-item>
        <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import rotas from '@/common/utils/rotas';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  props: {
    instituicoes: { type: Array, default: Array },
  },
  data() {
    return {
      campos: [
        {
          key: 'nome',
          label: this.$t('INSTITUICAO_ENSINO.NOME'),
          sortable: true,
        },
        {
          key: 'cnpj',
          label: this.$t('INSTITUICAO_ENSINO.CNPJ'),
          sortable: true,
          formatter: (value) => {
            let cnpj = value?.replace(/[^0-9A-Za-z]/g, '');
            cnpj = cnpj?.replace(
              /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2}).*/,
              '$1.$2.$3/$4-$5'
            );
            return cnpj;
          },
        },
        {
          key: 'razaoSocial',
          label: this.$t('INSTITUICAO_ENSINO.RAZÃO_SOCIAL'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
    };
  },
  methods: {
    // FUNÇÕES CRUD:
    excluir(item) {
      this.$emit('excluir', item);
    },
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
